interface EmptyImageProps {
    className?: string
}
export default function SidebarIcon({className}: EmptyImageProps) {
    return (
        <svg
             className={className}
             role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
            <path fill="currentColor"
                  d="M576 192C576 156.7 547.3 128 512 128L128 128C92.7 128 64 156.7 64 192L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 192zM400 304C400 290.7 410.7 280 424 280L504 280C517.3 280 528 290.7 528 304C528 317.3 517.3 328 504 328L424 328C410.7 328 400 317.3 400 304zM400 392C400 378.7 410.7 368 424 368L504 368C517.3 368 528 378.7 528 392C528 405.3 517.3 416 504 416L424 416C410.7 416 400 405.3 400 392zM352 464L128 464C119.2 464 112 456.8 112 448L112 192C112 183.2 119.2 176 128 176L352 176L352 464zM400 216C400 202.7 410.7 192 424 192L504 192C517.3 192 528 202.7 528 216C528 229.3 517.3 240 504 240L424 240C410.7 240 400 229.3 400 216z"></path>
        </svg>
    )
}
